import { render } from "./CRMDashboardCRMRealTimeEventsComponent.vue?vue&type=template&id=71672b53&scoped=true"
import script from "./CRMDashboardCRMRealTimeEventsComponent.vue?vue&type=script&lang=js"
export * from "./CRMDashboardCRMRealTimeEventsComponent.vue?vue&type=script&lang=js"

import "./CRMDashboardCRMRealTimeEventsComponent.vue?vue&type=style&index=0&id=71672b53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71672b53"]])

export default __exports__